import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import messages from './messages';
import styles from './style.module.less';
import { ChangeSubscriptionButtonWrapper } from '../../components/change-subscription-button-wrapper';
import { useTrackEvent, PageEvents, PageEventSourceStrings } from '../../hooks/use-track-event';
import { messages as commonMessages } from '../../messages';
import CancellationEntryPoint from '../../sections/cancellation/entry-point';

const TrialActions = ({ activeTrialAccount = false, canReactivateTrial = false, reactivatePlan = noop }) => {
  const trackEvent = useTrackEvent(PageEvents.SUBSCRIPTION_CHANGE_START, PageEventSourceStrings.SUBSCRIPTION_CARD);

  return (
    <div className={styles['trial-actions']}>
      {activeTrialAccount ? <CancellationEntryPoint inTrial /> : null}
      {canReactivateTrial ? (
        <Button className={styles.small} onClick={reactivatePlan} theme='link'>
          <FormattedMessage {...messages.undoCancellation} />
        </Button>
      ) : null}
      <ChangeSubscriptionButtonWrapper onClickTrack={trackEvent} theme='primary'>
        {activeTrialAccount ? <FormattedMessage {...commonMessages.selectPlan} /> : <FormattedMessage {...commonMessages.chooseAPlan} />}
      </ChangeSubscriptionButtonWrapper>
    </div>
  );
};

TrialActions.propTypes = {
  activeTrialAccount: PropTypes.bool,
  canReactivateTrial: PropTypes.bool,
  reactivatePlan: PropTypes.func,
};

export default TrialActions;
